export function moveConfigItemToFirstPosition(arr: any[], item: any): any[] {
  const newArr = [...arr];
  const foundIdx = newArr.findIndex((elem) => elem.Code == item);
  const foundItem = newArr[foundIdx];

  newArr.splice(foundIdx, 1);
  newArr.unshift(foundItem);

  return newArr;
}
